var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"uik-collapse"},on:{"before-enter":_vm.setup,"before-leave":_vm.setup,"enter":_vm.animateEnter,"leave":_vm.animateLeave,"after-enter":function($event){return _vm.finish('enter', $event)},"after-leave":function($event){return _vm.finish('leave', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }